import { defElement, defElements } from "./def.js";
export const anchor = defElement("a");
export const abbr = defElement("abbr");
export const br = defElement("br");
export const data = defElement("data");
export const quote = defElement("q");
export const time = defElement("time");
export const [cite, code, em, i, kbd, mark, small, span, strong, sub, sup] = defElements([
    "cite",
    "code",
    "em",
    "i",
    "kbd",
    "mark",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
]);
export const [del, ins] = defElements(["del", "ins"]);
